<template>
  <user-agreement :user-agreement-type="userAgreementType" showPageTitle></user-agreement>
</template>

<script>
import UserAgreement from '@/components/User/UserAgreement.vue';
import {isMobile} from "@/utilities/tools";
export default {
  name: "RewardRule",
  data () {
    return {
      userAgreementType: 3
    }
  },
  components: {
    UserAgreement
  },
  beforeMount () {
    if (!isMobile()) {
      window.location.href = `${process.env.VUE_APP_PC_URL}/Rccl.UserCenter/RewardRule`
    }
  },
  methods: {
  }
}
</script>

<style lang="less">
</style>